import { render, staticRenderFns } from "./injectionProduction.vue?vue&type=template&id=3b5440ac&scoped=true"
import script from "./injectionProduction.vue?vue&type=script&lang=js"
export * from "./injectionProduction.vue?vue&type=script&lang=js"
import style0 from "./injectionProduction.vue?vue&type=style&index=0&id=3b5440ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5440ac",
  null
  
)

export default component.exports